async function e(e){return new Promise((n=>setTimeout(n,e)))}export{e as wait};
